import SuccessCheckSparkle from './success-check-sparkle';

export default SuccessCheckSparkle;
